var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "user-picker-dialog",
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: "520px",
        "append-to-body": "",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.handleOpen,
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "div",
        { staticClass: "picker-body" },
        [
          _c("el-input", {
            staticClass: "picker-search",
            attrs: {
              placeholder: "搜索帐号名或用户名",
              "prefix-icon": "el-icon-search",
              clearable: "",
            },
            on: { input: _vm.onKeywordInput, clear: _vm.onSearchClear },
            model: {
              value: _vm.keyword,
              callback: function ($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword",
            },
          }),
          _vm.draftSelectedList.length > 0
            ? _c("div", { staticClass: "picker-selected" }, [
                _c("div", { staticClass: "picker-selected__head" }, [
                  _c("span", { staticClass: "picker-selected__label" }, [
                    _vm._v("已选"),
                  ]),
                  _c("span", { staticClass: "picker-selected__count" }, [
                    _vm._v(_vm._s(_vm.draftSelectedList.length) + " 人"),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "picker-selected__tags" },
                  _vm._l(_vm.draftSelectedList, function (user) {
                    return _c(
                      "span",
                      { key: user.userId, staticClass: "picker-tag" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "picker-tag__text",
                            attrs: {
                              title: user.userName + "（" + user.account + "）",
                            },
                          },
                          [_vm._v(" " + _vm._s(user.userName) + " ")]
                        ),
                        _c("i", {
                          staticClass: "el-icon-close picker-tag__remove",
                          attrs: {
                            role: "button",
                            "aria-label": "移除",
                            tabindex: "0",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.removeUser(user.userId)
                            },
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.removeUser(user.userId)
                            },
                          },
                        }),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading && _vm.userList.length === 0,
                  expression: "loading && userList.length === 0",
                },
              ],
              ref: "listScroll",
              staticClass: "picker-list",
              on: { scroll: _vm.onListScroll },
            },
            [
              _vm.userList.length > 0
                ? [
                    _vm._l(_vm.userList, function (user) {
                      return _c(
                        "div",
                        {
                          key: user.userId,
                          staticClass: "picker-list__item",
                          class: { "is-selected": _vm.isSelected(user.userId) },
                          attrs: { role: "button", tabindex: "0" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleUser(user)
                            },
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.toggleUser(user)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "picker-list__indicator",
                              class: {
                                "is-checked": _vm.isSelected(user.userId),
                              },
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _vm.isSelected(user.userId)
                                ? _c("i", { staticClass: "el-icon-check" })
                                : _vm._e(),
                            ]
                          ),
                          _c("div", { staticClass: "picker-list__info" }, [
                            _c("p", { staticClass: "picker-list__account" }, [
                              _vm._v(_vm._s(user.account)),
                            ]),
                            _c("p", { staticClass: "picker-list__name" }, [
                              _vm._v(_vm._s(user.userName)),
                            ]),
                          ]),
                        ]
                      )
                    }),
                    _vm.loadingMore
                      ? _c("div", { staticClass: "picker-list__footer" }, [
                          _c("i", { staticClass: "el-icon-loading" }),
                          _vm._v(" 加载中… "),
                        ])
                      : !_vm.hasMore
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "picker-list__footer picker-list__footer--muted",
                          },
                          [_vm._v("没有更多了")]
                        )
                      : _vm._e(),
                  ]
                : !_vm.loading
                ? _c("div", { staticClass: "picker-empty" }, [
                    _c("i", { staticClass: "el-icon-user" }),
                    _c("p", [_vm._v(_vm._s(_vm.emptyText))]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "picker-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "picker-footer__cancel",
              attrs: { type: "text" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              staticClass: "picker-footer__confirm",
              attrs: { type: "primary" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }